import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MaterialPage from "../components/MaterialPage";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const MaterialListPage = () => {
  const hasPermission = usePermission("materials", "view");

  return (
    <MasterLayout>
      <Breadcrumb title="Catalog" header="Material List" />
      {hasPermission ? <MaterialPage /> : <AccessDeniedLayer />}
    </MasterLayout>
  );
};

export default MaterialListPage;
